export const INTERNAL_TOAST_TYPES = {
  MAP_NOTIFICATIONS: "map_notifications",
  SERVICES_NOTIFICATIONS: "services_notifications",
  ERROR_NOTIFICATIONS: "error_notifications",
  DOWNLOAD_NOTIFICATIONS: "download_notifications",
  SEARCH_ENHANCED_RESULTS: "search_enhanced_results",
};

export const TOAST_STATUS = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error ",
};
